// extracted by mini-css-extract-plugin
export default {"rating":"mK-z","numberOfStars":"nK-z","count":"oK-z","barGraphSpacing":"pK-z","barGraph":"qK-z"};